import { migrateCardObjectToApiFormat } from '@shared/utils/api';

export const buildGetCardApiConfig = ({ cardId }) => ({
    url: `/api/cards/${cardId}`,
    method: 'GET',
});

export const buildEditCardApiConfig = ({ card }) => ({
    url: `/api/cards/${card.id}/edit`,
    method: 'PUT',
    data: migrateCardObjectToApiFormat(card),
});
